import { render } from "./SponsorCreateEdit.vue?vue&type=template&id=770dec26&scoped=true"
import script from "./SponsorCreateEdit.vue?vue&type=script&lang=js"
export * from "./SponsorCreateEdit.vue?vue&type=script&lang=js"

import "./SponsorCreateEdit.vue?vue&type=style&index=0&id=770dec26&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-770dec26"

export default script